/**
 *
 */
const init = function () {

	const select = document.getElementById('catFilterTermID');

	if ( select ) {
		select.addEventListener('change', function(ev) {
			if ( ev.target.value !== undefined ) {
				const url = ev.target.value;
				if ( url.includes('http') || url.includes('https') ) {
					window.location.href = url;
				}
			}
		})
	}

};

const api = {
	init: init
};

export default api;
